import { Layout } from './Layout';
import { LoginComponent } from './LoginComponent';

function Component() {
  return (
    <Layout>
      <LoginComponent />
    </Layout>
  );
}

export const LoginPage = Component;
